import UIButton from 'components/ui/form/UIButton'
import React from 'react'
import AIDALogo from "assets/icons/AIDA_logo_new_light.svg";
import AIDALogoDark from "assets/icons/AIDA_logo_new_dark.svg";
import CancelIcon from '@mui/icons-material/Cancel'
import { useNavigate } from 'react-router-dom'
import UICard from 'components/ui/card/UICard'
import { useSelector } from 'react-redux'
import OrieLogo from "assets/images/ORIE-logo-254x254.png"
import OrieLogoWhite from "assets/images/OrieLogo-White.png"

const ErrorFallback = props => {

	const app = useSelector((state) => state.app);
	const navigate = useNavigate()
	const { error, resetErrorBoundary } = props

	const retryChecking = () => {
		resetErrorBoundary()
	}

	const navigateToDashboard = () => {
		navigate('/home/dashboard')
		window.location.reload()
	}

	return (
		<>
			<div className="centered-justified-no-page">
				<div className="d-flex align-items-center">
					<img style={{width:"4rem"}} src={OrieLogo} alt="Orie Logo" />
					&emsp;<span className="hxl text-primary">Orie AI</span>
				</div>
				<div className="b1-primary my-3">
					<UICard
						customClasses="b1-primary shadow-lg p-5 m-md-5"
						jsx
						CardBody={
							<>
								<p className="text-center mb-3">
									<CancelIcon
										style={{ fontSize: 60 }}
										color="error"
									/>
								</p>
								<p className="fs text-center">
									Something went wrong while handling your
									request, please retry or
									<br />
									navigate to home.
								</p>
								<small className="fxs text-center">
									<p>What went wrong?</p>
									<p className="text-danger">
										{error?.message || ''}
									</p>
								</small>
							</>
						}
					/>
				</div>
				<div className="d-inline gx-2">
					<UIButton callback={retryChecking} text="Retry" />
					&emsp;
					<UIButton callback={navigateToDashboard} text="Dashboard" />
				</div>
			</div>
		</>
	)
}

export default ErrorFallback
